import { createAction, props } from '@ngrx/store';
import {
  IAccountPreferencesModel,
  IGetAccountReportExRequest,
  IGetPromoResponse,
  IToteAccountBalanceResponse,
  TError
} from '@amwager/util-ts';


/**
 * State
 */
export const initAccountState = createAction(
  '[Account] Init State',
  props<{
    sourceInitiator: string
  }>()
);
export const clearAccountState = createAction(
  '[Account] Clear State',
  props<{
    sourceInitiator: string
  }>()
);

export const loadAccountStateSuccess = createAction(
  '[Account] Load Account State Success'
);
export const loadAccountStateFailure = createAction(
  '[Account] Load Account State Failure',
  props<{ error: TError }>()
);



/**
 * GET Request
 */
export const getAccountBalanceAPI = createAction(
  '[Account_API] Get account balance',
  props<{
    sourceInitiator: string
  }>()
);

export const getUserEprotectInformationAPI = createAction(
  '[Account_API] Get account details'
);

export const getUserAccountAPI = createAction(
  '[Account_API] Get user account'
);

export const getAccountStatementsAPI = createAction(
  '[Account_API] Get account statements',
  props<{
    sourceInitiator: string,
    requests: IGetAccountReportExRequest
  }>()
);

export const getBetSummaryAPI = createAction(
  '[Account_API] Get bet summary',
  props<{
    sourceInitiator: string,
    requests: IGetAccountReportExRequest
  }>()
);

export const getOverviewAPI = createAction(
  '[Account_API] Get overview',
  props<{
    sourceInitiator: string,
    requests: IGetAccountReportExRequest
  }>()
);

export const selfExcludeOrSuspendAPI = createAction(
  '[Account_API] Post self exclude or suspend',
  props<{
    days: number,
    years: number,
    isExclusion: boolean
  }>()
);

export const selfExcludeOrSuspendVerificationAPI = createAction(
  '[Account_API] Post self exclude or suspend verification',
  props<{
    verificationToken: string
  }>()
);

export const getAccountPreferencesAPI = createAction(
  '[Account_API] Get account preferences'
);

/**
 * UPDATE Request
 */
export const upsertAccountPrefenceFieldAPI = createAction(
  '[Account_API] Update account preference field',
  props<{
    FieldName: string,
    Value: string
  }>()
);

export const getAccountDailyLossLimitAPI = createAction(
  '[Account_API] Get account daily loss limit '
);

export const getPromoListAPI = createAction(
  '[Account_API] Get promo list'
);

/**
 * Post Request
 */
export const useGiveAwayAPI = createAction(
  '[Account_API] Use give away',
  props<{
    giveAwayName: string
  }>()
);

export const usePromoAPI = createAction(
  '[Account_API] Use promo',
  props<{
    promoName: string
  }>()
);


/**
 * UPDATE Request
 */
export const updateAccountDailyLossLimitAPI = createAction(
  '[Account_API] Update account daily loss limit',
  props<{
    amount: number
  }>()
);


/**
 * GET Response SUCCESS
 */
export const getAccountBalanceAPISuccess = createAction(
  '[Account_API] Successfully get account balance',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: IToteAccountBalanceResponse }>()
);

export const getUserEprotectInformationAPISuccess = createAction(
  '[Account_API] Successfully get account details',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getUserAccountAPISuccess = createAction(
  '[Account_API] Successfully get user account',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getAccountStatementsAPISuccess = createAction(
  '[Account_API] Successfully get account statements',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getBetSummaryAPISuccess = createAction(
  '[Account_API] Successfully get bet summary',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getOverviewAPISuccess = createAction(
  '[Account_API] Successfully get overview',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const selfExcludeOrSuspendAPISuccess = createAction(
  '[Account_API] Successfully post self exclude or suspend',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const selfExcludeOrSuspendVerificationAPISuccess = createAction(
  '[Account_API] Successfully post self exclude or suspend verification',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const getAccountPreferencesAPISuccess = createAction(
  '[Account_API] Successfully get account preferences',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: IAccountPreferencesModel }>()
);

export const upsertAccountPrefenceFieldAPISuccess = createAction(
  '[Account_API] Successfully Update account preference field',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    fieldName: string,
    value: string
  }>()
);

export const upsertAccountPrefenceFieldAmwagerThemeAPISuccess = createAction(
  '[Account_API] Successfully Update account preference field amwager theme',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    fieldName: string,
    value: string
  }>()
);

export const upsertAccountPrefenceFieldFavoriteAPISuccess = createAction(
  '[Account_API] Successfully Update account preference field favorite',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    fieldName: string,
    value: string
  }>()
);

export const upsertAccountPrefenceFieldWageringLimitsAPISuccess = createAction(
  '[Account_API] Successfully Update account preference field wagering limits',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    fieldName: string,
    value: string
  }>()
);

export const getAccountDailyLossLimitAPISuccess = createAction(
  '[Account_API] Successfully get account daily loss limit',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: any }>()
);

export const updatetAccountDailyLossLimitAPISuccess = createAction(
  '[Account_API] Successfully Update account daily loss limit',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    amount: number
  }>()
);

export const getPromoListAPISuccess = createAction(
  '[Account_API] Successfully get promo list',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: IGetPromoResponse[] }>()
);

export const useGiveAwayAPISuccess = createAction(
  '[Account_API] Successfully use give away',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    successResponse: any
  }>()
);

export const usePromoAPISuccess = createAction(
  '[Account_API] Successfully use promo',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{
    successResponse: any
  }>()
);


/**
 * GET Response ERROR
 */
export const getAccountBalanceAPIFailed = createAction(
  '[Account_API] Failed to get account balance',
  props<{ errorResponse: TError }>()
);

export const getUserEprotectInformationAPIFailed = createAction(
  '[Account_API] Failed to get account details',
  props<{ errorResponse: TError }>()
);

export const getUserAccountAPIFailed = createAction(
  '[Account_API] Failed to get user account',
  props<{ errorResponse: TError }>()
);

export const getAccountStatementsAPIFailed = createAction(
  '[Account_API] Failed to get account statements',
  props<{ errorResponse: TError }>()
);

export const getBetSummaryAPIFailed = createAction(
  '[Account_API] Failed to get bet summary',
  props<{ errorResponse: TError }>()
);

export const getOverviewAPIFailed = createAction(
  '[Account_API] Failed to get overview',
  props<{ errorResponse: TError }>()
);

export const selfExcludeOrSuspendAPIFailed= createAction(
  '[Account_API] Failed to post self exclude or suspend',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ errorResponse: any }>()
);

export const selfExcludeOrSuspendVerificationAPIFailed= createAction(
  '[Account_API] Failed to post self exclude or suspend verification',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ errorResponse: any }>()
);

export const getAccountPreferencesAPIFailed = createAction(
  '[Account_API] Failed to get account preferences',
  props<{ errorResponse: TError }>()
);

export const upsertAccountPrefenceFieldAPIFailed = createAction(
  '[Account_API] Failed to update account preference field',
  props<{ errorResponse: TError }>()
);

export const getAccountDailyLossLimitAPIFailed = createAction(
  '[Account_API] Failed to get account daily loss limit',
  props<{ errorResponse: TError }>()
);

export const updateAccountDailyLossLimitAPIFailed = createAction(
  '[Account_API] Failed to update account daily loss limit',
  props<{ errorResponse: TError }>()
);

export const getPromoListAPIFailed = createAction(
  '[Account_API] Failed to get promo list',
  props<{ errorResponse: TError }>()
);

export const useGiveAwayAPIFailed = createAction(
  '[Account_API] Failed to use give away',
  props<{ errorResponse: TError }>()
);

export const usePromoAPIFailed = createAction(
  '[Account_API] Failed to use promo',
  props<{ errorResponse: TError }>()
);


/**
 * Properties
 */
export const setError = createAction(
  '[Account] Set an error',
  props<{
    error: TError,
    sourceInitiator: string
  }>()
);

export const setBalance = createAction(
  '[Account] Set balance',
  props<{
    balance: number,
    sourceInitiator: string
  }>()
);

export const clearGiveAway = createAction(
  '[Account] Clear give away'
);

export const clearPromo = createAction(
  '[Account] Clear promo'
);